import {
  ArrayMinSize,
  IsArray,
  IsObject,
  ValidateIf,
  ValidateNested,
} from "class-validator";
import { IAdapterEntityUpdateActionAsync } from "./adapter-entity-update-action-async.interface";
import { Type } from "class-transformer";
import { QueryDto } from "../query";

export class AdapterEntityUpdateActionAsyncDto implements Omit<
  IAdapterEntityUpdateActionAsync,
  "entity_name"
> {
  @ValidateIf((o) => !o.query)
  @IsArray()
  @ArrayMinSize(1)
  entity_ids?: string[]; //selected entities

  @ValidateIf((o) => !o.entity_ids)
  @IsObject()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;

  @IsObject()
  payload: any;
}
